import { UserOutlined } from '@ant-design/icons-vue';
import { AUTH_KEYS } from '@/constants';
import Layout from '@/layout/Layout.vue';

export default {
  path: '/project-managment',
  component: Layout,
  name: 'CaseManagement',
  meta: { title: 'case_management', root: true, auth: AUTH_KEYS.CASE_MANAGEMENT },
  children: [
    {
      name: 'ProjectManagement',
      path: '/project-managment',
      component: () => import('@/views/ProjectManagement/List.vue'),
      meta: { title: 'List', auth: AUTH_KEYS.CASE_MANAGEMENT, isHide: true }
    },
    {
      path: '/project-managment/popup',
      component: () => import('@/views/ProjectManagement/UploadFile.vue')
    },
    {
      path: '/project-managment/detail',
      name: 'ProjectDetailPrent',
      meta: {
        title: 'project_details_screen',
        isHide: true,
        noBreadcrumb: true,
        auth: AUTH_KEYS.CASE_MANAGEMENT_DETAILS
      },
      children: [
        {
          path: '/project-managment/detail/:id',
          name: 'ProjectDetail',
          component: () => import('@/views/ProjectManagement/Detail.vue'),
          meta: {
            title: 'project_details_screen',
            isHide: true,
            auth: AUTH_KEYS.CASE_MANAGEMENT_DETAILS
          },
          children: [
            {
              path: '/project-managment/create-quote/:id',
              name: 'QuoteCreation',
              component: () => import('@/views/QuotationCreate/Index.vue'),
              meta: {
                title: 'quote_register',
                isHide: true,
                auth: AUTH_KEYS.CASE_MANAGEMENT_DETAILS
              }
            }
          ]
        }
      ]
    }
  ]
};
